/** @enum string */
const ValueType = Object.freeze({
  /** @type {'key'} */ KEY: 'key',
  /** @type {'data-item'} */ DATA_ITEM: 'data-item',
})

export default ValueType
